<!--
* @description:
* @fileName shopList.vue
* @author hvv
* @date 2022/01/13 15:19:20
!-->
<template>
  <div></div>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  export default defineComponent({
    name: 'ShopList',
    setup() {},
  })
</script>
<style lang="scss" scoped></style>
